/*
 * @Description:
 * @Author: fal
 * @Date: 2025-02-28 10:17:10
 * @FilePath: \xhlz_pc\src\project\router\modules\supplier.js
 * @LastEditTime: 2025-09-24 16:09:30
 */
export const supplierRoutes = [
  // 控制面板
  {
    path: '/supplier/index',
    name: 'supplierIndex',
    component: () => import('@/project/views/supplier/panel/index'),
    meta: {
      title: '控制面板',
    },
  },
  // 企业资料
  {
    path: '/supplier/profile/index',
    name: 'supplierProfile',
    component: () => import('@/project/views/supplier/profile/index'),
    meta: {
      title: '企业资料',
    },
  },
  // 编辑企业资料
  {
    path: '/supplier/profile/edit',
    name: 'supplierProfileEdit',
    component: () => import('@/project/views/supplier/profile/editProfile'),
    meta: {
      title: '企业资料',
    },
  },
  // 资质证书
  {
    path: '/supplier/profile/cert',
    name: 'supplierCert',
    component: () => import('@/project/views/supplier/profile/cert'),
    meta: {
      title: '资质证书',
    },
  },
  // 账号管理
  {
    path: '/supplier/profile/permission',
    name: 'supplierPermission',
    component: () => import('@/project/views/supplier/profile/permission'),
    meta: {
      title: '账号管理',
    },
  },
  // 我的报价
  {
    path: '/supplier/infoMag/quote',
    name: 'supplierQuote',
    component: () => import('@/project/views/supplier/infoMag/quote'),
    meta: {
      title: '我的报价',
    },
  },
  // 信息管理
  // 招聘管理
  {
    path: '/supplier/infoMag/hire',
    name: 'supplierHire',
    component: () => import('@/project/views/supplier/infoMag/hire'),
    meta: {
      title: '招聘管理',
    },
  },
  // 发布、编辑招聘
  {
    path: '/supplier/infoMag/updateHire',
    name: 'supplierUpdateHire',
    component: () => import('@/project/views/supplier/infoMag/components/hire/updateInfo'),
    meta: {
      title: '人才招聘',
    },
  },
  // 查看招聘人才
  {
    path: '/supplier/infoMag/viewHire',
    name: 'supplierViewHire',
    component: () => import('@/project/views/supplier/infoMag/components/hire/viewInfo'),
    meta: {
      title: '查看人才招聘',
    },
  },
  {
    path: '/supplier/infoMag/laborQuoteList',
    name: 'supplierLaborQuoteList',
    component: () => import('@/project/views/supplier/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 劳务采购
  {
    path: '/supplier/infoMag/laborDemand',
    name: 'supplierLaborDemand',
    component: () => import('@/project/views/supplier/infoMag/laborDemand'),
    meta: {
      title: '劳务采购',
    },
  },
  {
    path: '/supplier/infoMag/laborQuoteList',
    name: 'supplierLaborQuoteList',
    component: () => import('@/project/views/supplier/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 材料采购发布
  {
    path: '/supplier/infoMag/material',
    name: 'supplierMaterial',
    component: () => import('@/project/views/supplier/infoMag/material'),
    meta: {
      title: '材料采购',
    },
  },
  {
    path: '/supplier/infoMag/materialQuoteList',
    name: 'supplierMaterialQuoteList',
    component: () => import('@/project/views/supplier/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 机械采购发布
  {
    path: '/supplier/infoMag/machine',
    name: 'supplierMachine',
    component: () => import('@/project/views/supplier/infoMag/machine'),
    meta: {
      title: '机械采购',
    },
  },
  {
    path: '/supplier/infoMag/machineQuoteList',
    name: 'supplierMachineQuoteList',
    component: () => import('@/project/views/supplier/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 咨询业务
  {
    path: '/supplier/infoMag/comprehensive',
    name: 'supplierComprehensive',
    component: () => import('@/project/views/supplier/infoMag/comprehensive'),
    meta: {
      title: '咨询业务',
    },
  },
  {
    path: '/supplier/infoMag/comprehensiveQuoteList',
    name: 'supplierComprehensiveQuoteList',
    component: () => import('@/project/views/supplier/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 平台推送
  {
    path: '/supplier/push',
    name: 'supplierPush',
    // component: () => import('@/project/views/supplier/push/push'),
    component: () => import('@/views/common/push/index.vue'),
    meta: {
      title: '平台推送',
    },
  },
  // 商品管理
  {
    path: '/supplier/goodsMag',
    name: 'supplierGoodsMag',
    component: () => import('@/project/views/supplier/goodsMag/index'),
    meta: {
      title: '商品管理',
    },
  },
  {
    path: '/supplier/goodsMag/update',
    name: 'supplierGoodsMag',
    component: () => import('@/project/views/supplier/goodsMag/update'),
    meta: {
      title: '商品管理',
    },
  },
  // 库存管理--材料入库
  {
    path: '/supplier/inventoryMag/storage',
    name: 'supplierStorage',
    component: () => import('@/project/views/supplier/inventoryMag/storage'),
    meta: {
      title: '材料入库',
    },
  },
  // 库存管理--材料出库
  {
    path: '/supplier/inventoryMag/outbound',
    name: 'supplierOutbound',
    component: () => import('@/project/views/supplier/inventoryMag/outbound'),
    meta: {
      title: '材料出库',
    },
  },
  // 库存管理--库存统计
  {
    path: '/supplier/inventoryMag/inventory',
    name: 'supplierInventory',
    component: () => import('@/project/views/supplier/inventoryMag/inventory'),
    meta: {
      title: '库存统计',
    },
  },
  // 库存管理--供应统计
  {
    path: '/supplier/inventoryMag/supply',
    name: 'supplierSupply',
    component: () => import('@/project/views/supplier/inventoryMag/supply'),
    meta: {
      title: '供应统计',
    },
  },
  // 工程项目
  {
    path: '/supplier/procedure',
    name: 'supplierProcedure',
    component: () => import('@/project/views/supplier/procedure'),
    meta: {
      title: '工程项目',
    },
  },
  // 工程项目--项目详情
  {
    path: '/supplier/procedure/project',
    name: 'supplierProject',
    component: () => import('@/project/views/supplier/procedure/project'),
    meta: {
      title: '项目详情',
    },
  },
];
